export const HOME_AUTO_INITIAL_ARTWORK_LIMIT = 10;
export const SUARTEWORLD_SEGMENT_ARTWORK_LIMIT = 32;

export const ARTWORK_CONTINUATION_POLICIES = {
  SUARTEWORLD: "suarteworld",
};
